import moment from "moment";
import html2pdf from "html2pdf.js";
import Modal from '@mui/material/Modal';
import { Link, useNavigate } from 'react-router-dom';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import { Download } from '@mui/icons-material';
import { ThreeDots } from 'react-loader-spinner';
import { useEffect, useMemo, useState } from 'react';
import ListItemText from '@mui/material/ListItemText';
import { useSelector, useDispatch } from "react-redux";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';


import 'react-circular-progressbar/dist/styles.css';
import { postRequest, showMessage } from "../../../../config";
import { toggleModal } from "../../../../reducers/modalReducer";
import Button from "../../../../components/common/Button/index.jsx";
import { setCompany } from "../../../../reducers/companyReducer.js";
import SortByDropdown from '../../../../components/common/dropdown';
import ModalWrapper from "../../../../components//common/Modal/ModalWrapper.jsx";
import CustomPagination from '../../../../components/common/pagination/CustomPagination';
import WarningInvestmentCriteria from "../../../../components/modals/WarningInvestmentCriteria/WarningInvestmentCriteria.jsx";

export default function QualifiedLeads({ loading, user, company, promptScore, qualifiedLeads, investors, saveInvestorMember, getQualifiedLeads, setQualifiedLeads }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const modal = useSelector(state => state.modal);
    let [selectedLead, setSelectedLead] = useState({});


    const handleInvestorMember = (leadId, member) => {
        if (typeof (member) == 'object') saveInvestorMember(leadId, member['_id']);
    };

    const { strongCount, mediumCount, lowCount } = useMemo(() => {
        if (!qualifiedLeads?.length) return { strongCount: 0, mediumCount: 0, lowCount: 0 };

        return qualifiedLeads.reduce((acc, investor) => {
            const score = investor.fitScorePercentage;
            if (score > 83) acc.strongCount++;
            else if (score >= 66.6 && score <= 83) acc.mediumCount++;
            else if (score < 66.6) acc.lowCount++;
            return acc;
        }, { strongCount: 0, mediumCount: 0, lowCount: 0 });
    }, [qualifiedLeads]);

    const downloadPDF = async () => {
        try {
            const wrapper = document.getElementById("table");
            const filename = [`DG-InvestorLeads-${company['cName'].substring(0, 7)}-[${moment(Date.now()).format("ll")}]`].join(" - ");
            const opt = { filename, jsPDF: { unit: 'mm', format: 'a2', orientation: 'p' } };
            await html2pdf().set(opt).from(wrapper).save();
        } catch (e) { console.error(e); }
    };

    const handleArchiveLead = async (investorId, clientId) => {
        let res = await postRequest(`/company/deleteInvestorLead`, { investorId, clientId });
        dispatch(toggleModal({ open: '' }));
        showMessage(res['message']);

        if (res && res['code'] == 200) {
            setQualifiedLeads([]);
            await getQualifiedLeads(company['_id']);
        }
    };

    const handleAddApplicant = () => {
        const invalidFields = ["annualProfits", "annualRevenues", "sweetSpot", "fundSize"].filter(key => company[key] === "Not known")
        if (invalidFields.length > 0 || !company['investment'] || !company['ukRegions'] || company['preferredSectors']['sector1'] === 'Not Selected' || !company['employees']) {
            dispatch(toggleModal({ open: 'warningToCompleteInvestmentCriteria' }))
        } else {
            navigate(`/manualAdd`)
        }

    }

    return (
        <div className="dropdown-company-dahboard leads-page poppins-font-style *">
            <div className="fs2rem df aic jcc c15 mt1rem">Investor<span className="c4 mr0-5rem">Match</span> Index</div>
            <div className="df jcsb pt0rem pl3rem pr3rem aife">
                <div className='df aife'>
                    <div className="df aic jcc">
                        <div onClick={handleAddApplicant} className="bo31 bw1px bss br50px c15 df aic jcc fs14px p0-5rem fw400 cp" style={{ height: '48px' }}>
                            <span className='mr0-5rem df aic'>
                                <img src={require('../../../../../images/investor-manual-add/manual-add-icon.svg')} alt='report' />
                            </span>
                            <span className="px0-5rem">Add Applicant</span>
                        </div>
                        <Link to={`/investor-setting#InvestorMatch%20Criteria`} className="bo31 bw1px bss br50px c15 df aic jcc fs14px p0-5rem fw400 cp ml1rem" style={{ height: '48px' }}>
                            <span className='mr0-5rem df aic'>
                                <img src={require('../../../../../images/investment-criteria-icon.svg')} alt='report' />
                            </span>
                            <span className="px0-5rem">Investment Criteria</span>
                        </Link>
                        {company?.['_id'] &&
                            <Link to={`/investorMatchStats?companyId=${company['_id']}`} className="bo31 bw1px bss br50px c15 df aic jcc fs14px p0-5rem fw400 cp ml1rem" style={{ height: '48px' }}>
                                <span className='mr0-5rem df aic'>
                                    <img src={require('../../../../../images/company-dashboard/report.svg')} alt='report' />
                                </span>
                                <span className="px0-5rem">Module Report/Stats</span>
                            </Link>
                        }
                        {qualifiedLeads && qualifiedLeads.length > 0 &&
                            <div onClick={downloadPDF} className='df aic jcc c1 bg3 py0-5rem px1-5rem br50px mr1rem cp fs14px ml1rem' style={{ height: '48px' }}>
                                <Download className="c1 mr0-5rem" />
                                Download PDF
                            </div>
                        }
                    </div>
                </div>
                <div className='df aife rightBar'>
                    {qualifiedLeads && qualifiedLeads.length > 0 &&
                        <div className='mr2rem'>
                            <SortByDropdown getQualifiedLeads={getQualifiedLeads} user={user} />
                        </div>
                    }
                    <div className={`progress-area-report progress-fit-report mb2rem`}>
                        <div className='progress-area' style={{ display: 'flex', position: 'relative', justifyContent: 'end', alignItems: 'center' }}>
                            <div className='progress-box'>
                                <div className="progress-bar" style={{ width: 80, height: 80, backgroundColor: '#FBFBFB', borderRadius: '50%' }}>
                                    <CircularProgressbar
                                        className={`${promptScore > 83 ? 'green' : promptScore > 66.6 ? 'orange' : 'red'}`}
                                        value={promptScore || 0}
                                        text={`${promptScore || 0}%`}
                                        strokeWidth={18}
                                        styles={buildStyles({
                                            strokeLinecap: 'round',
                                            strokeWidth: '5px',
                                            textSize: '18px',
                                            pathTransitionDuration: 0.5,
                                            trailColor: '#d6d6d6',
                                            backgroundColor: '#fc7785',
                                            dominantBaseline: 'ideographic',
                                        })}
                                    />
                                </div>
                                <span className="tooltip-area cp pr" style={{ top: '83px', left: '-24px', width: '14px' }}>
                                    <i className="icon">
                                        <svg classNaw2rem me="h2rem" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_2661_6508)">
                                                <path d="M9 18.1133C13.9628 18.1133 18 14.076 18 9.11328C18 4.15052 13.9628 0.113281 9 0.113281C4.03724 0.113281 0 4.15052 0 9.11328C0 14.076 4.03724 18.1133 9 18.1133ZM9 1.91328C12.97 1.91328 16.2 5.14326 16.2 9.11328C16.2 13.0833 12.97 16.3133 9 16.3133C5.02998 16.3133 1.8 13.0833 1.8 9.11328C1.8 5.14326 5.02998 1.91328 9 1.91328Z" fill="#FC7785" />
                                                <path d="M8.69665 11.6919C8.50359 11.6919 8.34746 11.5299 8.34746 11.3297C8.34746 10.8559 8.41225 10.4466 8.54117 10.1025C8.63575 9.84312 8.78929 9.5817 9.00049 9.31758C9.15597 9.12538 9.43454 8.84446 9.8375 8.47618C10.2405 8.10723 10.5022 7.81355 10.6233 7.59446C10.7445 7.37538 10.8041 7.13613 10.8041 6.87672C10.8041 6.40696 10.6272 5.995 10.2741 5.63949C9.92107 5.28398 9.48767 5.10656 8.97458 5.10656C8.47898 5.10656 8.06501 5.26785 7.73331 5.58976C7.49102 5.82497 7.30897 6.15696 7.18847 6.58573C7.10555 6.88008 6.82892 7.06825 6.53545 7.03196C6.16359 6.98627 5.9187 6.60454 6.02495 6.23156C6.18821 5.65831 6.4616 5.19661 6.84447 4.84581C7.37635 4.35723 8.07991 4.11328 8.95514 4.11328C9.88156 4.11328 10.6207 4.37471 11.1727 4.89823C11.7247 5.42175 12 6.05414 12 6.79608C12 7.22551 11.9028 7.62135 11.7091 7.9829C11.5154 8.34514 11.1358 8.78532 10.5715 9.30414C10.1925 9.65293 9.9444 9.91032 9.82778 10.0756C9.71117 10.241 9.62501 10.4312 9.5693 10.6455C9.52783 10.8048 9.49933 11.0387 9.48378 11.3458C9.47406 11.5394 9.31923 11.6912 9.13265 11.6912H8.69665V11.6919ZM8.28268 13.4258C8.28268 13.0461 8.57939 12.7383 8.94542 12.7383C9.31145 12.7383 9.60817 13.0461 9.60817 13.4258C9.60817 13.8055 9.31145 14.1133 8.94542 14.1133C8.57939 14.1133 8.28268 13.8055 8.28268 13.4258Z" fill="#FC7785" stroke="#FC7785" stroke-width="0.5" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_2661_6508">
                                                    <rect width="18" height="18" fill="white" transform="translate(0 0.113281)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <div className="overlay-box" style={{ left: 'auto', top: '0', right: '22px', zIndex: '9', width: '400px' }}>
                                            <p className="fs14px">"The Prompt Response Score is a score provided to each applicant company to indicate the promptness of any initial response from an investor – whether positive or negative". Any initial response that takes more than 10 days is marked negatively</p>
                                        </div>
                                    </i>
                                </span>
                                <span style={{ marginBottom: '0', fontSize: '13px' }} className="text-center-area c15">Prompt Response Score</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {(!company?.['_id'] || loading)
                ? <div class='df jcc aic py3rem'><ThreeDots height="80" width="80" color="#8496f4" ariaLabel="three-dots-loading" /></div>
                : qualifiedLeads && qualifiedLeads.length == 0
                    ? (<h2 className="w100 mt2rem c15 fs1-75rem lh2 tac fw500">No leads available</h2>)
                    : (<>
                        <div className="table-permission">
                            <table id="table" className="table-userPermissions table-clientPermissions table-leades">
                                <thead className="ps t0">
                                    <tr>
                                        <th className="index-table ttu fw500 compnay-name" style={{ textAlign: 'left !important', width: '300px' }}>Company</th>
                                        <th className="index-table ttu fw500 source" style={{ textAlign: 'left' }}>Source</th>
                                        <th className="index-table ttu fw500 email-date" style={{ textAlign: 'left' }}>Date Added</th>
                                        <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">
                                            <div className='br50px df fdc aifs'>
                                                <div className='df jcc aic mr0-5rem'>
                                                    <h3 className='green mr0-5rem fs10px'>{strongCount}</h3>
                                                    <p className='c15 fs10px'>Strong</p>
                                                </div>
                                                <div className='df jcc aic'>
                                                    <h3 className='orange mr0-5rem fs10px'>{mediumCount}</h3>
                                                    <p className='c15 fs10px'>Medium</p>
                                                </div>
                                                <div className='df jcc aic'>
                                                    <h3 className='red mr0-5rem fs10px'>{lowCount}</h3>
                                                    <p className='c15 fs10px'>Low</p>
                                                </div>
                                            </div>
                                            Fit Score
                                        </th>
                                        {/* <th className="index-table ttu fw500 fit-report" style={{ textAlign: 'left' }}>Fit<br />Report</th> */}
                                        <th className="index-table ttu fw500 allocated-member" style={{ textAlign: 'left' }}>Allocated<br />Member</th>
                                        <th className="index-table ttu fw500 accepted-rejected" style={{ textAlign: 'left' }}>Status </th>
                                        <th className="index-table ttu fw500 email-respond" style={{ textAlign: 'left' }}>Response <br />Email Date</th>
                                        <th className="index-table ttu fw500 archive" style={{ textAlign: 'left' }}>Diligentsia<br />Certification</th>
                                        <th className="index-table ttu fw500 archive" style={{ textAlign: 'left' }}>Archive</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {qualifiedLeads.map(lead => (
                                        <tr key={lead._id} style={{ backgroundColor: lead.isExampleCompany ? '#e6edf3' : 'transparent' }} >
                                            <td className="c15 compnay-name tal fs14px tal" style={{ width: '300px' }}>
                                                <Link className="c3 fs14px tal" to={`/company/${lead['clientId']}#diligence-pack`} onClick={() => { dispatch(setCompany({})), localStorage.setItem('isDiligencePack', true) }}>{lead['cName']}</Link>
                                            </td>
                                            <td className="c15 ttc source fs14px tal">{lead['source'] ? lead['source'] : '-'}</td>
                                            <td className="c15 email-date tal">{(lead?.['dateContacted'] && lead?.['dateContacted'] != 'Nil') ? moment(lead['dateContacted']).format('ll') : (lead?.['createdAt'] && lead?.['createdAt'] != 'Nil') ? moment(lead['createdAt']).format('ll') : '-'}</td>
                                            <td className="c15 fit-score tal">
                                                <div className="df jcfs">
                                                    <p className={`fs14px ml0-5rem tal ${lead['fitScorePercentage'] >= 83 ? 'green' : (lead['fitScorePercentage'] <= 82 && lead['fitScorePercentage'] >= 66.6) ? 'orange' : 'red'} `}>
                                                        {`${lead['fitScorePercentage']}%`}
                                                    </p>
                                                </div>
                                            </td>
                                            <td className="c15 allocated-member tal">
                                                <Select
                                                    className='w200px'
                                                    placeholder='Allocate to team'
                                                    name='investor-dropdown'
                                                    id='investor-dropdown'
                                                    labelId='investor-multiple-checkbox-label'
                                                    onChange={(e) => handleInvestorMember(lead['_id'], e.target.value)}
                                                    value={lead['investorMember'] || 'Allocate to team'}
                                                    renderValue={selected => {
                                                        if (typeof selected === 'string') {
                                                            return selected;
                                                        }
                                                        return (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-start' }}>
                                                                <img
                                                                    src={selected?.profile || selected?.profilePicture || require('../../../../../images/profile-photo.jpeg')}
                                                                    alt="profile"
                                                                    style={{ width: '32px', height: '32px', borderRadius: '50%', margin: '0px' }}
                                                                />
                                                            </div>
                                                        );
                                                    }}
                                                >
                                                    {!lead['investorMember'] && (
                                                        <MenuItem value='Allocate to team' className='multi-dropdown-list'>
                                                            <ListItemText primary='Allocate to team' />
                                                        </MenuItem>
                                                    )}
                                                    {investors.map((option) => (
                                                        <MenuItem key={option['_id']} value={option} className='multi-dropdown-list'>
                                                            <Checkbox checked={lead?.['investorMember']?._id === option['_id']} />
                                                            <ListItemText primary={`${option.firstName} ${option.lastName}`} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </td>
                                            {lead['leadStatus'] == 'Accepted'
                                                ? <td className="accepted-rejected tal green">Approved</td>
                                                : lead['leadStatus'] == 'Rejected'
                                                    ? <td className="accepted-rejected tal red">Rejected</td>
                                                    : <td className="accepted-rejected tal orange">Pending</td>
                                            }
                                            <td className="c15 email-respond tal">{lead['dateLeadStatus'] != 'Nil' ? moment(lead['dateLeadStatus']).format('lll') : <>-</>}</td>
                                            <td className="c15 archive tal" style={{ minWidth: '125px' }}>
                                                {lead['cLevel'] == 'Gold' ? <img class='w20' src={require(`../../../../../images/advisor-dashboard/banner-certification-4.png`)} alt="Certification" />
                                                    : lead['cLevel'] == 'Silver' ? <img class='w20' src={require(`../../../../../images/advisor-dashboard/banner-certification-3.png`)} alt="Certification" />
                                                        : lead['cLevel'] == 'Bronze' ? <img class='w20' src={require(`../../../../../images/advisor-dashboard/banner-certification-2.png`)} alt="Certification" />
                                                            : <img class='w20' src={require(`../../../../../images/advisor-dashboard/banner-certification-1.png`)} alt="Certification" />
                                                }
                                            </td>
                                            <td className="c15 archive tal" style={{ minWidth: '125px' }}>
                                                {lead.isExampleCompany ? (
                                                    <Tooltip title="This is an example of a company with a full diligence pack">
                                                        <InfoOutlinedIcon fontSize="medium" color="primary" className="cp" />
                                                    </Tooltip>
                                                ) : (
                                                    <img onClick={() => { setSelectedLead(lead), dispatch(toggleModal({ open: 'archiveLeadPopup' })) }}
                                                        src={require('../../../../../images/company-dashboard/delete.svg')} alt="delete" style={{ width: '24px', height: '24px', cursor: 'pointer' }} />
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <CustomPagination getQualifiedLeads={getQualifiedLeads} user={user} />
                        </div>
                    </>)}


            {/* Archive Lead Popup */}
            <ModalWrapper modalType={'archiveLeadPopup'}>
                <div className='df'>
                    <img className='w20' src={require(`../../../../../images/logo.svg`)} alt='TODO' />
                </div>
                <div className="row fdc tac">
                    <h1 className="c15 fs2rem fw600 tac ttu mb1rem">Archive Lead</h1>
                    <span className="c15 fs14px">Are you sure you want to archive <b>{selectedLead['cName']}</b>?</span>
                </div>
                <div className="df aic jcsa mt2rem">
                    <Button text={"Cancel"} onClick={() => dispatch(toggleModal({ open: '' }))} customClassName="c1 ml1rem" />
                    <Button text={"Archive"} btnType="warning" onClick={() => handleArchiveLead(company['_id'], selectedLead['clientId'])} />
                </div>
            </ModalWrapper>

            <WarningInvestmentCriteria />
        </div>
    )
}